import _ from 'lodash';

export const formatCategoryNameForUrl = name => _.kebabCase(name).replace(/-/g, '');



// WEBPACK FOOTER //
// ./src/services/category/utils.js